import { Box, Group, type GroupProps } from "@mantine/core";
import classNames from "classnames";
import "./ModalFooter.scss";

interface ModalFooterProps extends GroupProps {
  ref?: React.Ref<HTMLDivElement>;
}

function ModalFooter({
  ref,
  justify = "flex-end",
  ...props
}: ModalFooterProps) {
  return (
    <Box
      className={classNames("ModalFooter", props.className)}
      component="footer"
    >
      <Group
        className="footer-content"
        justify={justify}
        {...props}
        ref={ref}
      />
    </Box>
  );
}

export { ModalFooter };
